export default __webpack_public_path__ + "static/archie-98fb50b29fd49b1d21cdfbe45081a47c.jpg";